import React, { useState, useEffect, useRef, lazy, Suspense } from 'react';
import { CircularProgress } from '@mui/material';

import { useModalState } from 'contexts/modal';

const Alert = lazy(() => import('./alert'));
const UpdateMetaAds = lazy(() => import('../../GAME_SETTING/meta/ads/modal'))
const UpdateMetaVip = lazy(() => import('../../GAME_SETTING/meta/vip/modal'))
const CreateMetaTimeGift = lazy(() => import('../../GAME_SETTING/meta/timeGift/modal'))
const CreateMetaRandomBox = lazy(() => import('../../GAME_SETTING/meta/randombox/modal'))
const CreateMCODE = lazy(() => import('../../GAME_SETTING/mcode/modal'))

const CreateMaintenanceSchedule = lazy(() => import('../../GAME_MANAGEMENT/maintenance/schedule/modal'))
const CreateSystemNotice = lazy(() => import('../../GAME_MANAGEMENT/message/systemNotice/modal'))
const CreateMessageNotice = lazy(() => import('../../GAME_MANAGEMENT/message/notice/modal'))
const CreateTouPP = lazy(() => import('../../GAME_MANAGEMENT/message/touPP/modal'))
const CreateOperatorPayment = lazy(() => import('../../GAME_MANAGEMENT/message/operatorPayment/modal'))

const CreateOneLinkSchedule = lazy(() => import('../../GAME_MANAGEMENT/onelink/modal'))
const CreateBlacklist = lazy(() => import('../../GAME_MANAGEMENT/gateway/blacklist/modal'))
const CreateWhitelist = lazy(() => import('../../GAME_MANAGEMENT/gateway/whitelist/modal'))
const CreateGatewayOverride = lazy(() => import('../../GAME_MANAGEMENT/gateway/gateways/modal'))

const CreateLeagueData = lazy(() => import('../../GAME_MANAGEMENT/league/leagueData/modal'))
const CreateLeagueSchedule = lazy(() => import('../../GAME_MANAGEMENT/league/leagueSchedule/modal'))

const CreateAttendanceReward = lazy(() => import('../../GAME_MANAGEMENT/attendance/rewardsConfig/modal'))
const CreateAttendance = lazy(() => import('../../GAME_MANAGEMENT/attendance/control/modal'))

const CreateEventMultiRound = lazy(() => import('../../GAME_MANAGEMENT/event/main/modalRound'))
const CreateEventSub = lazy(() => import('../../GAME_MANAGEMENT/event/main/modalSub'))
const CreateEvent = lazy(() => import('../../GAME_MANAGEMENT/event/main/modal'))
const CreateEventRoulette = lazy(() => import('../../GAME_MANAGEMENT/event/main/modalRoulette'))

const CreateBingoBallRewards = lazy(() => import('../../GAME_MANAGEMENT/bingoBall/dailyReward/modal'))
const CreateBingoBallLeagues = lazy(() => import('../../GAME_MANAGEMENT/bingoBall/league/modal'))
const CreateBingoBallSchedule = lazy(() => import('../../GAME_MANAGEMENT/bingoBall/schedule/modal'))

const CreateCashMine = lazy(() => import('../../GAME_MANAGEMENT/cashMine/modal'))

const CreateMission = lazy(() => import('../../GAME_MANAGEMENT/mission/modal'))
const CreateMissionSub = lazy(() => import('../../GAME_MANAGEMENT/mission/modalSub'))
const CreateMissionSeasonalChapter = lazy(() => import('../../GAME_MANAGEMENT/mission/modalSeasonalChapter'))

const CreateMinigame = lazy(() => import('../../GAME_MANAGEMENT/minigame/modal'))
const CreateMinigameGacha = lazy(() => import('../../GAME_MANAGEMENT/minigame/modalGacha'))

const CreateSegmentSchedule = lazy(() => import('../../GAME_MANAGEMENT/segment/modal'))

const CreatePromoCoupon = lazy(() => import('../../GAME_MANAGEMENT/promoCode/promoCoupon/modal'))
const CreateInviteControl = lazy(() => import('../../GAME_MANAGEMENT/promoCode/inviteControl/modal'))
const CreateInviteQuest = lazy(() => import('../../GAME_MANAGEMENT/promoCode/inviteQuest/modal'))

const CreatePrizeRanking = lazy(() => import('../../GAME_MANAGEMENT/prizeRanking/modal'))
const CreatePrizeRankingSub = lazy(() => import('../../GAME_MANAGEMENT/prizeRanking/modalSub'))
const CreateWinnersTip = lazy(() => import('../../GAME_MANAGEMENT/winnersTip/modal'))

const CreateShopProduct = lazy(() => import('../../PRODUCT/shop/modal'))
const CreateSeqProduct = lazy(() => import('../../PRODUCT/group/modal'))
const CreateVipProduct = lazy(() => import('../../PRODUCT/vip/modal'))
const CreatePayback = lazy(() => import('../../PRODUCT/payback/modal'))
const CreatePaybackSub = lazy(() => import('../../PRODUCT/payback/modalSub'))

const BanPlayer = lazy(() => import('../../SEARCH_TOOL/accounts/findPlayer/modalBan'))
const EvaluateWithdrawal = lazy(() => import('../../SEARCH_TOOL/withdrawals/withdrawal/modal'))
const CreateTesterAccount = lazy(() => import('../../ETC/testerAccounts/modal'))
const ImportXLSXData = lazy(() => import('./import'))
const CreateGameVersion = lazy(() => import('../../GAME_SETTING/gameVersion/modal'))

const Modal = () => {
  const [alertElement, setAlertElement] = useState<any>();
  const [contentElement, setContentElement] = useState<any>();
  const elementEl = useRef(null);

  const { alert, content, options } = useModalState();

  useEffect(() => {
    setAlertElement(alert ? React.createElement(Alert) : null);
  }, [alert]);

  useEffect(() => {
    const process = async () => {
      let element: any = null;

      switch (content) {
        case 'UPDATE_META_ADS':
          element = UpdateMetaAds
          break;
        case 'UPDATE_META_VIP':
          element = UpdateMetaVip
          break;
        case 'CREATE_META_TIME_GIFT':
          element = CreateMetaTimeGift
          break;
        case 'CREATE_RANDOM_BOX':
          element = CreateMetaRandomBox
          break;
        case 'CREATE_RANDOM_BOX':
          element = CreateMetaRandomBox
          break;
        case 'CREATE_MCODE':
          element = CreateMCODE
          break;
        case 'CREATE_MAINTENANCE_SCHEDULE':
          element = CreateMaintenanceSchedule
          break;
        case 'CREATE_MESSAGE_NOTICE':
          element = CreateMessageNotice
          break;
        case 'CREATE_SYSTEM_NOTICE':
          element = CreateSystemNotice
          break;
        case 'CREATE_TOUPP':
          element = CreateTouPP
          break;
        case 'CREATE_OPERATOR_PAYMENT':
          element = CreateOperatorPayment
          break;
        case 'CREATE_GATEWAY_OVERRIDE':
          element = CreateGatewayOverride
          break;
        case 'CREATE_BLACKLIST':
          element = CreateBlacklist
          break;
        case 'CREATE_WHITELIST':
          element = CreateWhitelist
          break;
        case 'CREATE_LEAGUE_DATA':
          element = CreateLeagueData
          break;
        case 'CREATE_LEAGUE_SCHEDULE':
          element = CreateLeagueSchedule
          break;
        case 'CREATE_ATTENDANCE_REWARD':
          element = CreateAttendanceReward
          break;
        case 'CREATE_ATTENDANCE':
          element = CreateAttendance
          break;
        case 'CREATE_EVENT':
          element = CreateEvent
          break;
        case 'CREATE_EVENT_MULTI_ROUND':
          element = CreateEventMultiRound
          break;
        case 'CREATE_EVENT_SUB':
          element = CreateEventSub
          break;
        case 'CREATE_BINGO_BALL_REWARDS':
          element = CreateBingoBallRewards
          break;
        case 'CREATE_BINGO_BALL_LEAGUES':
          element = CreateBingoBallLeagues
          break;
        case 'CREATE_BINGO_BALL_SCHEDULE':
          element = CreateBingoBallSchedule
          break;
        case 'CREATE_CASH_MINE':
          element = CreateCashMine
          break;
        case 'CREATE_EVENT_ROULETTE':
          element = CreateEventRoulette
          break;
        case 'CREATE_MISSION':
          element = CreateMission
          break;
        case 'CREATE_MISSION_SUB':
          element = CreateMissionSub
          break;
        case 'CREATE_MISSION_SEASONAL_CHAPTER':
          element = CreateMissionSeasonalChapter
          break;
        case 'CREATE_MINIGAME':
          element = CreateMinigame
          break;
        case 'CREATE_MINIGAME_GACHA':
          element = CreateMinigameGacha
          break;
        case 'CREATE_PROMO_COUPON':
          element = CreatePromoCoupon
          break;
        case 'CREATE_INVITE_CONTROL':
          element = CreateInviteControl
          break;
        case 'CREATE_INVITE_QUEST':
          element = CreateInviteQuest
          break;
        case 'CREATE_PRIZE_RANKING':
          element = CreatePrizeRanking
          break;
        case 'CREATE_PRIZE_RANKING_SUB':
          element = CreatePrizeRankingSub
          break;
        case 'CREATE_SEGMENT':
          element = CreateSegmentSchedule
          break;
        case 'CREATE_ONELINK_SCHEDULE':
          element = CreateOneLinkSchedule
          break;
        case 'CREATE_WINNERS_TIP':
          element = CreateWinnersTip
          break;
        case 'CREATE_SHOP_PRODUCT':
          element = CreateShopProduct
          break;
        case 'CREATE_SEQ_PRODUCT':
          element = CreateSeqProduct
          break;
        case 'CREATE_VIP_PRODUCT':
          element = CreateVipProduct
          break;
        case 'CREATE_PAYBACK':
          element = CreatePayback
          break;
        case 'CREATE_PAYBACK_SUB':
          element = CreatePaybackSub
          break;
        case 'BAN_PLAYER':
          element = BanPlayer
          break;
        case 'EVALUATE_WITHDRAWAL':
          element = EvaluateWithdrawal
          break;
        case 'CREATE_TESTER':
          element = CreateTesterAccount
          break;
        case 'IMPORT_XLSX_DATA':
          element = ImportXLSXData
          break;
        case 'CREATE_GAME_VERSION':
          element = CreateGameVersion
          break;
      }

      setContentElement(element ? React.createElement(element) : null)
    }

    process()
  }, [content])

  return alertElement || contentElement ? (
    <div
      ref={elementEl}
      style={{ position: 'relative', display: 'inline-block' }} >

      <Suspense fallback={<CircularProgress />}>

        {alertElement && React.cloneElement(alertElement, options)}

        {contentElement && (
          <div style={{ display: alertElement ? 'none' : 'inline-block' }} >
            {React.cloneElement(contentElement, options)}
          </div>
        )}

      </Suspense>

    </div>
  ) : null
}

export default Modal;
